import React from "react"
import styled from "styled-components"
import {H2, Body} from "@irati/ui/src/Typography"

const ProductsHeader = () => {
  return (
    <Container>
      <Title>
        <H2>Home and Electronics</H2>
      </Title>

      <ResultsInfoSection>
        <Body>Showing 0 - 40 of 332 results</Body>
      </ResultsInfoSection>

      <FiltersSection>
        <FilterGroup>
          <label>Results per page:</label>
          <select>
            <option>40</option>
            <option>80</option>
            <option>120</option>
          </select>
        </FilterGroup>

        <FilterGroup>
          <label>Sort by:</label>
          <select>
            <option>Popularity</option>
            <option>Price (Low to High)</option>
            <option>Price (High to Low)</option>
          </select>
        </FilterGroup>
      </FiltersSection>
    </Container>
  )
}

export default ProductsHeader

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  max-width: 1280px;
  margin: 30px auto 16px auto;
  background-color: ${({theme}) => theme.colors.greys.grey03};

  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    flex-direction: column;
    align-items: flex-start;
  `}
`

const Title = styled.div`
  padding: 8px;
  flex: 1;

  h2 {
    margin: 0;
  }
`

const ResultsInfoSection = styled.div`
  padding: 8px;
  flex: 1;
  text-align: center;

  p {
    margin: 0;
  }

  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    text-align: left;
    margin-top: 8px;
  `}
`

const FiltersSection = styled.div`
  padding: 8px;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  `}
`

const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  label {
    font-size: 12px;
    font-weight: 500;
  }

  select {
    padding: 4px 8px;
    font-size: 12px;
  }
`
